export default __webpack_public_path__ + "static/media/bg-banner-cta-2.900921b5.jpg";